import getOptionsTypeLabel from '../../getOptionsTypeLabel';
import type { Language, ProcessCellCallbackParams, SelectOption } from '../../../types/common';
import type { OptionsType } from '../../../types/options';

const tradingCompanyCellCallback = (params: ProcessCellCallbackParams): string => {
  const code: string = params.value;
  const tradingCompany: OptionsType[] = params.context?.tradingCompany ?? [];
  const currentLang: SelectOption<Language> | undefined = params.context?.currentLang;
  const targetTradingCompany: OptionsType | undefined = tradingCompany.find((company) => company.code === String(code));
  const tradingCompanyName: string = targetTradingCompany ? getOptionsTypeLabel(targetTradingCompany, currentLang.value) : code;
  return tradingCompanyName;
};

export default tradingCompanyCellCallback;
